const currencyFormatter = {
  VND: new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }),
  vi: new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }),
  default: new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }),
} as any

const formatCurrency = (value: number, locale: string) => {
  return (currencyFormatter[locale] ?? currencyFormatter.default)
    .format(value)
    .replace(/\s+/g, "")
}

const formatCurrencyWithoutSymbol = (value: number, locale: string) => {
  return (currencyFormatter[locale] ?? currencyFormatter.default)
    .format(value)
    .replace("₫", "")
    .replace(/\s+/g, "")
}

const meterToKilometer = (value: number) => {
  const kilometer = value / 1000
  if (kilometer >= 10) return kilometer.toFixed(0)
  return kilometer.toFixed(1)
}

const formatAroundNumber = (value: number): number | string => {
  if (value >= 10000) return "999+"
  if (value >= 1000) return "999+"

  return value
}

const formatNoOfOrder = (value: number): string => {
  if (value > 1000) return "1000+"
  if (value > 500) return "500+"
  if (value > 100) return "100+"
  if (value > 50) return "50+"
  if (value > 10) return "10+"

  return `${value}`
}

const formatNoOfFoodItemOrder = (value: number): string => {
  if (value > 1000) return "1000+"

  return `${value}`
}

export {
  formatCurrency,
  formatCurrencyWithoutSymbol,
  meterToKilometer,
  formatAroundNumber,
  formatNoOfOrder,
  formatNoOfFoodItemOrder,
}
